import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import HeroImg2 from '../components/HeroImg2';
import Form from '../components/Form';
import ContactImage from '../assets/contact.jpg';  // Import the contact image

const Contact = () => {
  return (
    <div className="contact-page">
      <Navbar />
      <HeroImg2
        heading="CONTACT."
        text="Let's get in touch."
        imageSrc={ContactImage}  // Pass the image as a prop
      />
      <Form />
      <Footer />
    </div>
  );
};

export default Contact;
